import React, { useContext, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { Context } from "../inc/state";
import { Actions, MaskedInput } from "./fields";
import errorMessages from "../inc/errorMessages";
import * as Yup from "yup";
import axios from "axios";
import qs from "qs";
import Spinner from "react-bootstrap/Spinner";

export default () => {
	const [state, dispatch, setLoading] = useContext(Context);
	const [error, setError] = useState("");
	const { isLegalEntity } = state;

	const handleSubmit = (values, { setSubmitting }) => {
		setSubmitting(true);
		setError("");
		dispatch({ type: "ADD_DATA", payload: { values } });
		values.isLegalEntity = isLegalEntity;

		axios
			.post(`${process.env.REACT_APP_API_URL}submit.php`, qs.stringify(values))
			.then((r) => {
				if (r.data.success) {
					dispatch({ type: "STEP_FORWARD" });
				} else {
					const e = r.data.e
						? r.data.e
						: "Er is een probleem opgetreden bij het verwerken van uw verzoek. Gelieve opnieuw in te dienen.";
					setError(e);
				}

				setSubmitting(false);
			})
			.catch((r) => {
				setSubmitting(false);
				const e = r.data.e
					? r.data.e
					: "Er is een probleem opgetreden bij het verwerken van uw verzoek. Gelieve opnieuw in te dienen.";
				setError(e);
			});
	};

	const validationSchema = Yup.object().shape({
		fund_commitment: Yup.string().required(errorMessages.required),
		fund_iBan: Yup.string().required(errorMessages.required),
		gdpr: Yup.bool().oneOf([true], 'U dient akkoord te gaan met het privacybeleid'),
	});

	const initialValues = state.values;

	return (
		<Formik
			initialValues={initialValues}
			onSubmit={handleSubmit}
			validationSchema={validationSchema}
		>
			{({ values, isSubmitting }) => (
				<Form>
					<h4 className="mb-4">Commitment</h4>
					<MaskedInput
						mask="€num"
						blocks={{
							num: {
								mask: Number,
								thousandsSeparator: ".",
								min: 250000,
							},
						}}
						label="Commitment (minimum €250.000,00)"
						name="fund_commitment"
						id="fund_commitment"
						placeholder="€500.000"
					/>
					<MaskedInput
						mask="aa** **** **** **** **** **** *** **"
						label="Bankrekeningnummer (IBAN)"
						name="fund_iBan"
						id="fund_iBan"
						placeholder="BE68123412341234"
						text="Bankrekeningnummer waarop de uitkeringen van het Fonds zullen worden overgemaakt."
					/>

					<div className="form-check">
						<Field
							type="checkbox"
							name="gdpr"
							id="gdpr"
							className="form-check-input"
						/>
						<label className="form-check-label" htmlFor="gdpr">
							Ik heb het{" "}
							<a
								href="https://integra.fund/wp-content/uploads/2022/05/Integra-Fund_Privacy-Policy.pdf"
								target="_blank"
								rel="noreferrer"
							>
								privacybeleid
							</a> gelezen en ga hiermee akkoord
						</label>
						<ErrorMessage name="gdpr">
							{(msg) => <div className="invalid-feedback d-block">{msg}</div>}
						</ErrorMessage>
					</div>

					{isSubmitting && (
						<div className="mt-5">
							<Spinner animation="border" />
						</div>
					)}
					{!isSubmitting && <Actions />}
					{error && (
						<div className="alert alert-danger mt-3" role="alert">
							{error}
						</div>
					)}
				</Form>
			)}
		</Formik>
	);
};
